import { ZION_BUILD } from '../buildInfo.ts'

const BUILD_KEY = 'zion_web_build'

export function markBuildLoaded(): void {
  try {
    localStorage.setItem(BUILD_KEY, ZION_BUILD)
  } catch {
    /* ignore */
  }
}

export function storedBuild(): string | null {
  try {
    return localStorage.getItem(BUILD_KEY)
  } catch {
    return null
  }
}

/** Svuota cache SW + ricarica — necessario su iPhone/PWA con app.js in cache. */
export async function forceRefreshApp(): Promise<void> {
  try {
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map((k) => caches.delete(k)))
    }
  } catch {
    /* ignore */
  }
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((r) => r.unregister()))
    }
  } catch {
    /* ignore */
  }
  try {
    localStorage.setItem(BUILD_KEY, ZION_BUILD)
  } catch {
    /* ignore */
  }
  const url = new URL(window.location.href)
  url.searchParams.set('_bust', ZION_BUILD)
  url.searchParams.set('_t', String(Date.now()))
  window.location.replace(url.toString())
}
